'use client';
import i18next from 'i18next';
import { getOptions } from './config';

i18next.init({
  ...getOptions(),
});

export default i18next;
